import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { ArrowRight, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you are looking for could not be found." />
      <section className="py-24 md:py-32 bg-white border-b border-neutral-200">
        <div className="max-w-3xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <div className="font-heading text-7xl sm:text-8xl font-bold text-[#A91D22] tracking-tight">404</div>
          <h1 className="font-heading mt-6 text-3xl sm:text-4xl font-semibold text-neutral-900 tracking-tight">This page couldn't be found.</h1>
          <p className="mt-4 text-neutral-600">The page you're looking for may have been moved, renamed or removed.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" className="inline-flex items-center gap-2 bg-neutral-900 text-white px-6 py-3 text-sm font-medium hover:bg-neutral-800 rounded-sm" data-testid="404-return-home">
              <ArrowLeft size={16} /> Return Home
            </Link>
            <Link to="/products" className="inline-flex items-center gap-2 border border-neutral-300 text-neutral-900 px-6 py-3 text-sm font-medium hover:bg-neutral-50 rounded-sm" data-testid="404-browse-products">
              Browse Products <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
